import React from 'react'
import client1 from './client1.png'
import client2 from './client2.png'
import client3 from './client3.png'
import Slider from "react-slick";
import './Testimonial.css'
import {RiStarSFill} from 'react-icons/ri'
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

export default function Testiomonial() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
  
    return (
        <div className="row test_container g-0 mb-5 py-5" id='reviews'>
        <div className="col-lg-5 mx-auto col-md-6 col-9 text-center">
   <div className='test_title mt-2'> <h1  className='my_happy'>Happy Clients Says</h1></div>
    <div className='testimonial'>
        
        <Slider {...settings}>
      <div className='testimonial_content text-center'>
       <div className="test_image d-flex justify-content-center mt-5 my-4"><img src={client1} className="test_img" alt="" /></div>
       <div className="client_name"><h4>Thomas Keller</h4></div>
       <div className="test_stars"><div className="stars"><RiStarSFill/><RiStarSFill/><RiStarSFill/><RiStarSFill/><RiStarSFill/></div> </div>
       <div className="test_description px-lg-5 mt-4 mb-5">Lorem ipsum dolor sit amet consectetur magni eius? Maiores explicabo impedit non quia placeat!</div>
      </div>
      <div className='testimonial_content text-center'>
       <div className="test_image d-flex justify-content-center mt-5 my-4"><img src={client2} className="test_img" alt="" /></div>
       <div className="client_name"><h4>Grant Achatz</h4></div>
       <div className="test_stars"><div className="stars"><RiStarSFill/><RiStarSFill/><RiStarSFill/><RiStarSFill/><RiStarSFill/></div> </div>
       <div className="test_description px-lg-5 mt-4 mb-5">Lorem ipsum dolor sit amet consectetur magni eius? Maiores explicabo impedit non quia placeat!</div>
      </div>
      <div className='testimonial_content text-center'>
       <div className="test_image d-flex justify-content-center mt-5 my-4"><img src={client3} className="test_img" alt="" /></div>
       <div className="client_name"><h4>Wolfgang Puck</h4></div>
       <div className="test_stars"><div className="stars"><RiStarSFill/><RiStarSFill/><RiStarSFill/><RiStarSFill/><RiStarSFill/></div> </div>
       <div className="test_description px-lg-5 mt-4 ">Lorem ipsum dolor sit amet consectetur magni eius? Maiores explicabo impedit non quia placeat!</div>
      </div>
      
      
    </Slider>
    </div>
        </div>
        </div>
  )
}
